import { render, staticRenderFns } from "./OrderCalculatorReceive.vue?vue&type=template&id=58d13cc4&scoped=true&"
import script from "./OrderCalculatorReceive.vue?vue&type=script&lang=js&"
export * from "./OrderCalculatorReceive.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalculatorReceive.vue?vue&type=style&index=0&id=58d13cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d13cc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCard,VCardText,VSheet,VWindow,VWindowItem})
